import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Practice from "@/pages/Practice";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/practice" element={<Practice />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: { background: "#1b1408", color: "#f2c14e", borderRadius: 0, border: "2px solid #1b1408", fontFamily: "ui-monospace, Menlo, monospace" },
        }}
      />
    </div>
  );
}

export default App;
